export default {
  all: {},
  search: {},
}
